export default __webpack_public_path__ + "static/media/vinciworks_logo_white.69a51c71.svg";